// Remembers the campaign / area link a visitor arrived from (utm_campaign —
// every area short link like /surfcoast lands on /?utm_campaign=surfcoast)
// so it can be saved on their profile as signup_source if they sign up
// within 30 days. Last touch wins: a newer link replaces an older one.
const KEY = 'hireit_signup_source'
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000

const clean = (s) => (s || '').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 50)

export function captureSignupSource() {
  try {
    const source = clean(new URLSearchParams(window.location.search).get('utm_campaign'))
    if (source) localStorage.setItem(KEY, JSON.stringify({ source, at: Date.now() }))
  } catch (e) {
    // storage blocked (private mode etc.) — just don't record a source
  }
}

export function getSignupSource() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (saved?.source && Date.now() - saved.at < MAX_AGE_MS) return saved.source
  } catch (e) {}
  return null
}
